<template>
    <div class="content with-pagination">
        <router-view @refresh="refresh()"></router-view>
        <header class="content-header">
            <div class="wrapper">

                <div>
                    <h1>Factures</h1>
                    <p>Gestion des factures</p>

                    <div class="datagrid-results"><strong>{{paginator.total}}</strong> Résultats trouvés</div>
                </div>

              <actions-dropdown>
                <li v-if="$aclInterfaceValidator('weeboxcore.invoice.export')" @click="exportFile('invoices')">
                  <icon name="download-cloud-01"/>
                  <span>Export les résultats (Excel)</span>
                </li>
                <li v-if="$aclInterfaceValidator('weeboxcore.invoice.export')" @click="exportFileForBanana('banana_invoices')">
                  <icon name="download-cloud-01"/>
                  <span>Export Banana (CSV)</span>
                </li>
                <li v-if="$aclInterfaceValidator('weeboxcore.invoice.import')" @click="importFile()">
                  <icon name="upload-cloud-01"/>
                  <span>Importer des paiements</span>
                </li>
              </actions-dropdown>


            </div>
        </header>

        <filters v-model="filters" :paginator="paginator" :tabs="tabsFilter" :active-client-filter="true" :active-advanced-filter="false" @refresh="refresh()" @setInputsValue="setInputsValue" @setFilter="setFilter" active-advanced-filter="true"></filters>

        <div class="content-body">

            <section>

                <no-results v-model="resources" :clear="resetFilter"></no-results>

                <div v-if="resources && resources.length" class="datagrid" :class="paginator.listing">
                    <div class="datagrid-header">
                        <div>
                            <div></div>
                            <div class="picture"></div>
                            <div>
                              <datagrid-sort :data="[{name:'Référence', value:'reference'}]" v-model="paginator"></datagrid-sort>
                            </div>
                            <div class="right">
                              <datagrid-sort :data="[{name:'Montant', value:'amount_total'}, {name:'CA Total', value:'ca_total'}]" label="Montant" name="amount_total" v-model="paginator"></datagrid-sort>
                            </div>
                            <div class="center"><span>Paiement</span></div>
                            <div class="center">
                              <datagrid-sort :data="[{name:'Payé le', value:'paied_at'}, {name:'Rappel', value:'due_at'}]" v-model="paginator"></datagrid-sort>
                            </div>
                            <div><span>Succursale</span></div>
                            <div class="center">
                              <datagrid-sort :data="[{name:'Facturation', value:'invoiced_at'}]" v-model="paginator"></datagrid-sort>
                            </div>
                            <div class="center"><span>Scopes</span></div>
                            <div class="actions"></div>
                            <div></div>
                        </div>
                    </div>
                    <div class="datagrid-body">
                        <div v-for="item in resources" @dblclick="edit(item.id)">
                            <div></div>
                            <div class="picture">
                                <i class="icon icon-order-success status-completed" v-if="item.payment_status  == 'completed'"></i>
                                <i class="icon icon-order-pending status-pending" v-if="item.payment_status  != 'completed'"></i>
                            </div>
                            <div data-field="reference">
                                <strong class="highlight">{{ item.reference }}</strong>
                                <p v-if="item.clientable_id && item.address_billing">{{ item.client_type == 'company' ? item.address_billing.company : (item.address_billing ? item.address_billing.firstname + ' ' + item.address_billing.lastname : item.firstname + " " + item.lastname ) }}<br><span v-if="item.address_billing && item.address_billing.postal_code">{{ item.address_billing.postal_code }}</span> <span v-if="item.address_billing && item.address_billing.locality">{{ item.address_billing.locality }}</span></p>
                                <p v-if="item.clientable_id && !item.address_billing && item.clientable">{{ item.clientable.name }}</p>
                                <p v-if="!item.clientable_id">Anonyme</p>
                            </div>
                            <div data-field="amount_total ca_total" class="right">
                                <span class="price highlight"><i>{{ item.currency }}</i> {{ item.amount_total|formatNumber}}</span>
                                <span class="price"><i>{{ item.currency }}</i> {{ item.ca_total|formatNumber}}</span>
                                <p v-if="item.currency_base != item.currency">{{ item.currency_base }} {{ item.amount_total_converted|formatNumber}}</p>
                                <p v-if="item.detail_payment" class="truncate">{{ item.detail_payment.provider }}</p>
                            </div>
                            <div style="text-align: left;">
                              <order-status :type="item.payment_status"/>
                              <!--<a :href="item.payment_link" target="_blank">Payer</a>-->
<!--                                <ul class="process" style="margin: 0;">-->
<!--                                    <li class="draft" v-bind:class="item.payment_status  == 'draft'?'active':''" v-if="item.payment_status == 'draft'"><span>Brouillon</span></li>-->
<!--                                    <li class="pending" v-bind:class="item.payment_status  == 'pending' || item.payment_status  == 'started'?'active':''" v-if="item.payment_status != 'draft'"><span>En attente</span></li>-->
<!--                                    <li class="completed" v-bind:class="item.is_transaction_completed > 0?'active':''" v-if="item.payment_status != 'draft'"><span>Payé</span></li>-->
<!--                                    <li class="cancel active" v-if="item.payment_status  == 'canceled'"><span>Annulé</span></li>-->
<!--                                    <li class="cancel active" v-if="item.payment_status  == 'error'"><span>Erreur</span></li>-->
<!--                                </ul>-->
                            </div>
                            <div data-field="paied_at due_at">
                              <date v-if="item.paied_at" v-model="item.paied_at" :human="false"></date>
                              <span v-if="item.due_at" style="color: red;font-weight: bold;">{{ item.due_at }} jours</span>
                            </div>
                            <div style="font-size: 12px;">
                                <p v-if="item.user" style="margin-bottom: 4px;"><i class="icon icon-icon_person"></i> {{ item.user.name }}</p>
                                <p v-if="item.branch_id"><i class="icon icon-location"></i> {{ getBranchById(item.branch_id) }}</p>
                                <!--<div v-if="item.is_transaction_completed <= 0"><a :href="item.payment_link" target="_blank">Payer</a></div>-->
                            </div>
                            <div data-field="invoiced_at" class="center">
                              <date v-model="item.invoiced_at" :human="false"></date>
                            </div>
                            <div data-field="scope" class="center"><scopes v-model="item.scopes" v-if="item.scopes"></scopes></div>
                            <div class="actions">
                                <ul>
                                    <li><button @click="remove(item.id)"><icon name="trash-01"/></button></li>
                                    <li><button @click="edit(item.id)"><icon name="pencil-02"/></button></li>
                                </ul>
                            </div>
                            <div></div>
                        </div>
                    </div>
                </div>

            </section>

            <component-paginator v-model="paginator" v-on:refresh="refresh"></component-paginator>

        </div>
    </div>
</template>
<script>
    import InvoiceService from './InvoiceService.js';
    import Index from '../../../layouts/Index.vue';
    import UserService from "../../scope/UserService.js";
    import BranchService from "../../config/branch/BranchService";

    export default {
        extends: Index,
        data () {
            return {
                tabsFilter: [
                    {
                        slug: '',
                        name: 'Tout'
                    },
                    {
                        slug: 'draft',
                        name: 'Brouillon'
                    },
                    {
                        slug: 'pending',
                        name: 'En attente'
                    },
                    {
                        slug: 'paied',
                        name: 'Payé'
                    },
                    {
                        slug: 'canceled',
                        name: 'Annulé'
                    }
                ],
                branches: []
            }
        },
        mounted: function(){
            this.refresh();

            this.filters.inputs.push({
                name: 'Traité par',
                slug: 'user',
                type: 'autocomplete',
                service: UserService,
                mandatory: false,
                options: [],
                has_languages: false,
                value: null,
            });

            BranchService.query().then(response => {
                this.branches = response.data.data
                this.isLoading = false

                this.filters.inputs.push({
                    name: 'Branche',
                    slug: 'branch',
                    type: 'select',
                    service: null,
                    mandatory: false,
                    options: this.branches,
                    has_languages: false,
                    value: null,
                });
            })

        },
        methods: {
            getBranchById: function(id){
                var branch = null;
                for(let item of this.branches)
                {
                    if(item.id == id){
                        return item.name;
                    }
                }
            },
            getResource: function(){
                return InvoiceService;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/invoicing/invoice/Index.vue